import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row type ───

export interface ChartingTemplateRow {
  id: string;
  org_id: string;
  clinic_id: string | null;
  name: string;
  description: string | null;
  image_url: string | null;
  image_file_id: string | null;
  category: string | null;
  config: string | null;
  status: string;
  created_by_user_id: string | null;
  created_at: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

// ─── Queries ───

/**
 * All active charting templates for the org (PRD.171).
 * Newest first.
 */
export function qChartingTemplates(orgId: string): QuerySpec<[string]> {
  return {
    key: ['charting_templates', 'by-org', orgId] as const,
    sql: `SELECT * FROM charting_templates WHERE org_id = ? AND status = 'active' ORDER BY created_at DESC`,
    params: [orgId],
    watch: ['charting_templates'],
  };
}
